module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sliders/sliders.component.scss
// module id = ./src/app/sliders/sliders.component.scss
// module chunks = main